import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';

import { defaultBorder, defaultPadding } from '../styles/common';

const CardFooter = ({
	children,
	isColumn,
}) => {

	const styles = StyleSheet.create({
		footer: {
			paddingHorizontal: !isColumn ? defaultPadding : undefined,
			paddingVertical: defaultPadding / 2,
			borderBottomRightRadius: defaultBorder,
			borderBottomLeftRadius: defaultBorder,
			flexDirection: isColumn ? 'column' : 'row-reverse',
		},
	});

	return (
		<View style={styles.footer}>
			{children}
		</View>
	);
};



export default memo(CardFooter);